"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSelectedFilter = exports.transformLocationParam = exports.decodeFilters = exports.decodeFiltersValue = exports.encodeFilterValue = exports.SearchParamsBuilder = void 0;
const lists_1 = require("src/lists");
class SearchParamsBuilder {
    constructor() {
        this.searchParams = new URLSearchParams();
        this.Append = (name, value, valueConverter = null) => {
            if (value !== undefined) {
                if (valueConverter) {
                    value = valueConverter(value);
                }
                this.searchParams.append(name, value);
            }
        };
        this.AppendArray = (name, values, valueConverter = null) => {
            if (values !== undefined) {
                if (valueConverter) {
                    values = values.map(valueConverter);
                }
                values.forEach(value => this.Append(name, value)); // no need to return any value
            }
        };
        this.toString = () => this.searchParams.toString();
    }
}
exports.SearchParamsBuilder = SearchParamsBuilder;
const encodeFilterValue = (name, value, separator = ':') => {
    return `${name}${separator}${encodeURIComponent(value)}`;
};
exports.encodeFilterValue = encodeFilterValue;
const decodeFiltersValue = (filters, separator = '=') => {
    return filters
        ? filters.map(filterItem => {
            const [name, value] = filterItem.split(separator);
            return `${name}${separator}${decodeURIComponent(value)}`;
        })
        : filters;
};
exports.decodeFiltersValue = decodeFiltersValue;
const decodeFilters = (filters) => {
    return filters
        ? filters.map(filterItem => {
            return decodeURIComponent(filterItem);
        })
        : filters;
};
exports.decodeFilters = decodeFilters;
const transformLocationParam = (location) => {
    let result = '';
    if (location) {
        result = Array.isArray(location) ? location.join(', ') : location;
    }
    return result;
};
exports.transformLocationParam = transformLocationParam;
const getSelectedFilter = (selectedFilters, groupFilter, itemFilter = '') => {
    const values = Array.isArray(selectedFilters) ? selectedFilters : selectedFilters[groupFilter];
    return (0, lists_1.getFirstOrDefault)(values, '', itemValue => {
        const filterValue = (0, exports.encodeFilterValue)(groupFilter, itemFilter);
        if (itemFilter) {
            return itemValue === filterValue;
        }
        return itemValue.indexOf(filterValue) !== -1;
    });
};
exports.getSelectedFilter = getSelectedFilter;
